module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_0.468aafc9.png";